import React from "react";
import { Button, Dialog, Stack, Typography, Divider } from "@mui/material";

export default function ConfirmBankAccountModal({
  open,
  setOpen,
  handleYes = () => {},
  accountNumber,
  ifscCode,
  bankName,
  note,
}) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <Stack spacing={3} padding={4}>
        <Typography variant="h6" fontWeight={600}>
          Confirm Bank Account
        </Typography>

        <Stack spacing={1.5} sx={{ backgroundColor: "#f9f9f9", p: 2, borderRadius: 2 }}>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Bank Name
            </Typography>
            <Typography fontWeight={500}>{bankName}</Typography>
          </Stack>

          <Divider />

          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Account Number
            </Typography>
            <Typography fontWeight={500}>{accountNumber}</Typography>
          </Stack>

          <Divider />

          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              IFSC Code
            </Typography>
            <Typography fontWeight={500}>{ifscCode}</Typography>
          </Stack>
        </Stack>

        {note && (
          <Typography variant="body2" color="text.secondary" fontStyle="italic">
            Note: {note}
          </Typography>
        )}

        <Stack direction="row" justifyContent="flex-end" spacing={2}>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" onClick={() => { handleYes(); handleClose(); }}>
            Confirm
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
}
